import { fromJS, List } from 'immutable';
import { normalizeEntities } from 'helpers/utilHelpers';
import {
  LOAD_NOTIFICATIONS_SUCCESS,
  LOAD_DRAWER_TASKS_SUCCESS,
  TOGGLE_NOTIFICATION_DRAWER,
  TOGGLE_TASK_VIEW,
  VIEW_NOTIFICATION_SUCCESS,
  LOAD_PROJECTS_SUCCESS,
  VIEW_ALL_NOTIFICATION_SUCCESS,
  CHANGE_NOTIFICATION_FILTERS,
  TASK_VIEW_COMMENT_NOTIFICATIONS_SUCCESS,
  DELETE_NOTIFICATION_SUCCESS,
  APPEND_NEW_FEED,
} from 'constants/ActionTypes';

const initialState = fromJS({
  visible: false,
  loading: {
    notifications: true,
    projects: true,
    tasks: true,
  },
  projects: {},
  notifications: {},
  taskView: {
    isVisible: false,
    taskId: null,
  },
  filters: {
    all: true,
  },
  pagination: {
    totalCount: null,
    pageCount: null,
    currentPage: 1,
    perPage: null,
    newTotalCount: null,
  },
  notificationDataset: [],
  taskList: {
    dataset: [],
    pagination: {
      totalCount: null,
      pageCount: null,
      currentPage: null,
      perPage: null,
    },
  },
});

const notificationDrawerReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_NOTIFICATION_DRAWER:
      return state.set('visible', !state.get('visible'));
    case LOAD_PROJECTS_SUCCESS:
      return state
        .set('projects', normalizeEntities(action.projects.items, 'projectId'))
        .setIn(['loading', 'projects'], false);
    case LOAD_DRAWER_TASKS_SUCCESS: {
      let dataset = new List();
      if (action.tasks._meta.currentPage > 1) {
        dataset = state.getIn(['taskList', 'dataset']);
      }
      return state
        .setIn(['loading', 'tasks'], false)
        .setIn(['taskList', 'dataset'], dataset.concat(fromJS(action.tasks.items.map((task) => task.taskId))))
        .setIn(
          ['taskList', 'pagination'],
          fromJS({
            totalCount: action.tasks._meta.totalCount,
            pageCount: action.tasks._meta.pageCount,
            currentPage: action.tasks._meta.currentPage,
            perPage: action.tasks._meta.perPage,
          }),
        );
    }
    case APPEND_NEW_FEED: {
      const notifications = [action.payload];
      let newState = state
        .set('notifications', normalizeEntities(notifications, 'feedId', state.get('notifications')))
        .setIn(['loading', 'notifications'], false);

      notifications.forEach((item) => {
        if (!newState.get('notificationDataset').includes(item.feedId)) {
          newState = newState.set('notificationDataset', newState.get('notificationDataset').push(item.feedId));
        }
      });

      return newState;
    }
    case LOAD_NOTIFICATIONS_SUCCESS: {
      let newState = state
        .set('notifications', normalizeEntities(action.notifications.items, 'feedId', state.get('notifications')))
        .setIn(['loading', 'notifications'], false);

      action.notifications.items.forEach((item) => {
        if (!newState.get('notificationDataset').includes(item.feedId)) {
          newState = newState.set('notificationDataset', newState.get('notificationDataset').push(item.feedId));
        }
      });

      return newState.set(
        'pagination',
        fromJS({
          totalCount: action.notifications._meta.totalCount,
          pageCount: action.notifications._meta.pageCount,
          currentPage: action.notifications._meta.currentPage,
          perPage: action.notifications._meta.perPage,
          newTotalCount: action.notifications._meta.newTotalCount,
        }),
      );
    }
    case TASK_VIEW_COMMENT_NOTIFICATIONS_SUCCESS: {
      let review = 0;
      action.values.forEach((feed) => {
        const viewed = state.getIn(['notifications', feed.feedId, 'viewed'], null);
        if (viewed !== null && viewed !== feed.viewed) {
          review++;
        }
      });
      const newTotalCount = state.getIn(['pagination', 'newTotalCount']) - review;
      return (
        state
          .set('notifications', normalizeEntities(action.values, 'feedId', state.get('notifications')))
          // Default value is 'review' for if not exist return 'review' - 'review' value 0
          .setIn(['pagination', 'newTotalCount'], newTotalCount > 0 ? newTotalCount : 0)
      );
    }
    case VIEW_NOTIFICATION_SUCCESS: {
      const exists = state.getIn(['notifications', action.notification.feedId]);
      if (!exists) {
        return state.setIn(['notifications', action.notification.feedId], fromJS(action.notification));
      }

      let newCount = state.getIn(['pagination', 'newTotalCount']);
      newCount = newCount ? (action.notification.viewed ? newCount - 1 : newCount + 1) : null;

      return state
        .setIn(['notifications', action.notification.feedId, 'viewed'], action.notification.viewed)
        .setIn(['pagination', 'newTotalCount'], newCount > 0 ? newCount : null);
    }
    case TOGGLE_TASK_VIEW:
      return state.set(
        'taskView',
        fromJS({
          isVisible: !state.getIn(['taskView', 'isVisible']),
          taskId: action.taskId,
          commentId: action.commentId,
          inProject: action.inProject,
        }),
      );
    case VIEW_ALL_NOTIFICATION_SUCCESS: {
      const notifications = state.get('notifications').map((notification) => {
        if (!notification.get('viewed')) {
          return notification.set('viewed', 1);
        }
        return notification;
      });
      return state.set('notifications', notifications).setIn(['pagination', 'newTotalCount'], 0);
    }
    case CHANGE_NOTIFICATION_FILTERS:
      return state.set('filters', fromJS(action.filters));
    case DELETE_NOTIFICATION_SUCCESS:
      return state.deleteIn(['notifications', action.feedId]);
    default:
      return state;
  }
};

export default notificationDrawerReducer;
